import styled from 'styled-components'
import { colors } from 'shared/lib'

const Divider = styled.div`
  border-bottom: 1px solid ${colors.FC2_LIGHTEST_GREY};
  margin: 20px 0;
`
export default Divider
